<template>
  <div>
    <!-- Note must be disable until load all selected data if select all is clicked -->
    <v-select
      :value="selected_keys"
      :items="selected_keys.map(it => ({value: it,name: selected[it]}))"
      :label="props.label"
      :class="[
        props.class || props.readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input',
        { required: props.required },
      ]"
      :placeholder="props.placeholder"
      outlined
      dense
      multiple
      :hide-selected="dialog"
      :disabled="props.readonly || props.disabled || dialog || loading_select"
      :rules="rules"
      background-color="#f2f2f2"
      item-text="name"
      @click.stop="toggle_dialog"
      @mousedown.prevent
      @change="change_items"
    >
      <template v-slot:append>
        <v-icon v-if="!props.readonly && !props.disabled && ((value || []).length > 0)" @click.stop="clear_all" @mousedown.stop>
          mdi-close
        </v-icon>
        <v-icon v-if="!props.readonly && !props.disabled && ((value || []).length > 0) && props.multiple" @click.stop>
          mdi-eye
        </v-icon>
        <v-icon v-if="!props.readonly && !props.disabled && !loading_select" color="primary">
          mdi-menu-down
        </v-icon>
        <v-progress-circular
          v-else-if="!props.readonly && !props.disabled && loading_select"
          indeterminate
          color="primary"
          :size="20"
        />
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip small v-if="index < 3">{{ item.name }}</v-chip>
        <div v-else-if="(value || []).length > 3 && index == 3" class="text-caption">{{"(+" + ((value || []).length - 3) + ")"}} </div>
      </template>
    </v-select>
    <ModalDialog
      :title=" $vuetify.lang.translator('select')+ ' ' + props.label"
      :showModalDialog="dialog"
      @submit="submit_dialog"
      @close-dialog="toggle_dialog"
      @clear="clear"
    >
      <!-- TODO: Use GenericExplorer and not TableTable -->
      <template v-slot:modal_content="">
        <ExplorerHeader2
          :filters="apply_filters"
          hide_add_button
          disable_views
          :props="view_props['ExplorerTable']"
          @update="update_filters"
        ></ExplorerHeader2>
        <div v-if="qunits && qunits.length" class="genericexplorer-table-cont">
            <TableTable
              :qunits="qunits"
              :filters="apply_filters"
              :loading="loading"
              :view_props="{
                'checkbox': true,
                'selectable': true,
                'multiselect':props.multiple,
                'actions': true,
                'navigate': false,
                'server_pagination': true,
                'expandable': false,
                'action_list':['ActionViewQUnit'],
                'table_class': 'primary lighten-5',
              }"
              :already_selected="Object.keys(selected_before_submit)"
              table_class="qmkey-explorer-table table-contrast-expand-icon mt-0 primaryl1"
              @update="update_table"
              @update_filters="update_table"
              @click="select_qunit"
              @select_all="select_all"
            />
          </div>
          <!-- NO DATA -->
          <v-container
            v-else
          >
            <v-row align="center" justify="center">
              <!-- LOADING -->
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
                class="mt-5"
              ></v-progress-circular>
              <div
                v-else
                class="mt-5"
              >
                {{ $vuetify.lang.translator('explorer.no_data') }}
              </div>

            </v-row>
          </v-container>
      </template>
      <!-- TODO: Use GenericExplorer and not TableTable -->
      <!--
      <template v-else v-slot:modal_content="">
        <GenericExplorer
          ref="explorer"
          :filters="apply_filters"
          :views="available_views(is_mobile,view_props)"
          :is_mobile="is_mobile"
          :state="state"
          :items_to_select="Object.keys(selected_before_submit)"
          hide_add_button
          @update_selection="update_selection"
          @select_all="select_all"
        />
      </template>
      -->
    </ModalDialog>
  </div>
</template>

<style lang="scss">
</style>

<script>
import { mapGetters, mapState } from 'vuex'
import QUnitCollection from '@/qunit/QUnitCollection'
import TableTable from '@/components/explorer/table/TableTable'
import { QFilters, get_qfilter, url_to_filters } from '@/qunit/filters';
  export default {
    components: {
      ModalDialog : () => import('@/components/explorer/ModalDialog'),
      ExplorerHeader2 : () => import('@/components/explorer/ExplorerHeader2'),
      QUnitCollection,
      TableTable,
      GenericExplorer: () => import('@/components/explorer/GenericExplorer'),
    },

    name: 'RelatedSelect',

    props: ['props', 'current_unit'],

    data: () => ({
      valid: true,
      dialog: false,
      base_filters: new QFilters(),
      apply_filters: new QFilters(),
      loading: false,
      loading_select: false,
      qunits: new QUnitCollection([]),
      selected: {},
      selected_before_submit: {},
      all_selected: false,
      view_props: {
        'ExplorerTable': {
          'selectable': true,
          'multiselect': true,
          'server_pagination': true,
          'navigate': false,
          'function': QUnitCollection.getQUnitRelated,
          'checkbox': true,
          'actions': true,
          'expandable': true,
          'action_list':['ActionViewQUnit'],
          'table_class': 'primary lighten-5',
          'header_props': {
            'hide_divider': true,
            'hide_tabs': true,
            'hide_title': true,
          },
        },
      },
      state: null,
    }),

    computed: {
      ...mapGetters([
        'sitePath',
        'centro_id'
      ]),
      ...mapState(['is_mobile']),
      value() {
        if (this.selected_keys.length > 0) {
          return this.selected_keys;
        } else {
          return  null;
        }
      },
      rules() {
        // TODO: Multilang: Change hardcoded string
        return [(value) => (!!value && value.length > 0) || !this.props.required || this.$vuetify.lang.translator('required_field')]
      },
      selected_keys() {
        return Object.keys(this.selected || {}).filter(it => (this.props.value || []).includes(it));
      }
    },

    mounted() {
      this.setup_filters();
      this.refresh();
      if (this.props.items) {
        for(let [key,value] of this.props.items) {
          this.selected[key] = value;
        }
        this.selected = {...this.selected};
        this.selected_before_submit = {...this.selected};
      }

    },
    methods: {

      available_views(is_mobile,props) {
        let views = [{name: 'ExplorerTable',...props['ExplorerTable'],'already_selected': Object.keys(this.selected_before_submit)}];
        return views;
      },

      validate() {
        return this.valid;
      },

      error_state(ok) {
        this.valid = ok;
      },

      setup_filters() {
        this.base_filters = new QFilters();
        this.base_filters.set_filter(get_qfilter('centro', this.centro_id))
        this.base_filters.set_filter(get_qfilter('business_process', this.props.target_business_process))
        this.base_filters.set_filter(get_qfilter('page', 1))
        this.base_filters.set_filter(get_qfilter('sort_by', "current_workflow_limit"));
        this.base_filters.set_filter(get_qfilter('sort_desc', false));
        
        this.apply_filters = this.base_filters.copy();
        
        // Current qunit uid for backend
        this.base_filters.set_filter(get_qfilter('pk', this.current_unit ? this.current_unit.uid : ""))
      },

      change_items(items) {
        for (let [id,item] of Object.entries(this.selected_before_submit)) {
          if (!items.includes(id)) {
            delete this.selected[id]
            delete this.selected_before_submit[id]
            this.selected = {...this.selected}
            this.selected_before_submit = {...this.selected_before_submit}
          }
        }
        this.valid = this.value && this.value.length > 0;
        this.update(Object.keys(this.selected));
      },

      selected_items(items) {
        
      },

      toggle_dialog() {
        
        if (!this.props.readonly && !this.props.disabled) {
          this.dialog = !this.dialog;
          this.set_selected();
        }
      },

      submit_dialog(form) {
        if (this.all_selected && (Object.keys(this.selected_before_submit).length != this.qunits.count)) {
          this.set_select_all();
        } else {
          const values = Object.keys(this.selected_before_submit);
          this.selected = {...this.selected_before_submit};
          this.update(Object.keys(this.selected));
        }
        this.toggle_dialog();
        this.valid = this.value && this.value.length > 0;
        // this.update(Object.keys(this.selected));
      },

      clear_all() {
        this.clear();
        this.selected = {};
        this.update();
      },

      clear() {
        this.unselect_all();
      },

      update_table(filters) {
        this.apply_filters = this.apply_filters.merge(filters)
        this.$nextTick(() => {
          this.refresh();
        })
      },

      update_filters(filters) {
        this.apply_filters = this.apply_filters.merge(filters)
        this.refresh();
      },
      
      refresh() {
        if (!this.props.readonly && !this.props.disabled) {
          this.loading = true;
          QUnitCollection
            .getQUnitRelated(this.base_filters.merge(this.apply_filters))
            .then(qc => {
              this.loading = false;
              this.qunits = qc;

              this.apply_filters.set_filter(get_qfilter('page', qc.page))       
            })
            .catch(err => {
              this.loading = false;
              console.error(err);
            });
        }
      },

      set_selected() {
        if (this.value) {
          for(let select of this.value) {
            let found = this.qunits.units.find(it => it.uid == select)
            if (found) {
              this.selected[found.uid] = found.title+'';
            }
          }
        } else {
          this.selected = {};
        }
        this.selected_before_submit = {...this.selected};
      },

      select_all(all) {
        this.all_selected = all;
        if (!all) {
          this.unselect_all();
        }
      },

      set_select_all() {
        // this should be a async call
        this.loading_select = true;
        let filter = this.base_filters.merge(this.apply_filters);
        filter.set_filter(get_qfilter('units_per_page', this.qunits.count))
        QUnitCollection
          .getQUnitRelated(filter)
          .then(qc => {
            this.loading = false;
            if (qc.units) {
              this.selected = {};
              qc.units.forEach(it => this.selected[it.uid] = it.title+'');
              this.selected_before_submit = {...this.selected};
            }
            this.loading_select = false;
            this.update(Object.keys(this.selected));
          })
          .catch(err => {
            this.loading_select = false;
            console.error(err);
          });
      },

      unselect_all() {
        this.selected_before_submit = {...{}};
      },

      update_selection(selected) {
        this.selected_before_submit = selected;
      },

      select_qunit(qunit) {
        if(!this.props.multiple) {
          this.unselect_all();
        }
        if (this.selected_before_submit[qunit.uid]) {
          delete this.selected_before_submit[qunit.uid];
          this.selected_before_submit = {...this.selected_before_submit}
        } else {
          this.selected_before_submit = {...this.selected_before_submit,[qunit.uid]: qunit.title};
        }
        this.all_selected = Object.keys(this.selected_before_submit).length == this.qunits.count;
      },

      update(items) {
        this.$emit('update',items);
      },
    },
  }
</script>